import React from "react";

const logos = [
  { src: "/logos/BAIR_Logo.png", alt: "BAIR" },
  { src: "/logos/Google__G__logo.svg.png", alt: "Google G" },
  { src: "/logos/netflix-symbol-black.png", alt: "Netflix" },
  { src: "/logos/vercel0.webp", alt: "Vercel" },
  { src: "/logos/unnamed.png", alt: "Partner logo" },
  { src: "/logos/images.png", alt: "Partner logo" },
  { src: "/logos/images (1).png", alt: "Partner logo" },
  { src: "/logos/images (2).png", alt: "Partner logo" },
  { src: "/logos/avatars-JUvAAPvAA86fmbVE-SH0i6g-t240x240.jpg", alt: "Partner logo" },
];

const TeamSection: React.FC = () => {
  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white">
      <style>{`
        @keyframes logo-marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-2xl lg:text-3xl font-light text-gray-900 leading-relaxed mb-6">
            We're all AI Researchers, Fortune 500 engineers, and exited founders.
          </p>
          <p className="text-base text-gray-600 max-w-3xl mx-auto leading-relaxed">
            We've assembled a team of the most technical minds from leading AI labs and Fortune 500 companies to collaborate and build sustainable, production-ready solutions for companies we care about.
          </p>
        </div>

        {/* Company Logos - Marquee */}
        <div className="overflow-hidden flex justify-center px-6 max-w-[760px] mx-auto">
          <div
            className="flex items-center whitespace-nowrap gap-3"
            style={{ animation: "logo-marquee 12s linear infinite", width: "200%" }}
          >
            {[...logos, ...logos].map((logo, idx) => (
              <div key={idx} className="h-12 w-24 flex items-center flex-shrink-0 justify-center px-2">
                <img
                  src={logo.src}
                  alt={logo.alt}
                  className="h-full w-auto max-w-[120px] object-contain rounded-lg bg-white shadow-sm p-1"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
